import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Cattle, CattleNode } from "./models/LivestocksCountingModel";

export default class LivestocksCountingeVuexModule extends AbacoVuexModule {
    @State() cattles!: Cattle[];
    @State() cattleNodes!: CattleNode[];
    @State({ default: false }) canView!: boolean;
    @State({ default: false }) canEdit!: boolean;
}
